<template>
  <div v-if="Images">
    <div class="mainImage">
      <a data-fancybox="gallery" :href="myImages[mainImage.index][mainImage.n]._url"><img :src="myImages[mainImage.index][mainImage.n]._url"></a>
    </div>
    <div class="subImage">
      <div id="carouselExampleControls" class="carousel slide" data-interval="false" data-ride="carousel">
        <div class="carousel-inner" style="padding:0 25px">
          <div class="carousel-item" v-for="(arrImages , index) in myImages" :key="index" v-bind:class="{active : index==0}">
            <div class="row">
              <div class="col-3 imageItem" v-for="(Image , n) in arrImages" :key="n">
                <a data-fancybox="gallery" @mouseover="changeMainImage(index , n)" :href="Image._url"><img :src="Image._url"></a>
              </div>  
            </div>
          </div> 
        </div>
        <a class="carousel-control-prev"  href="#carouselExampleControls" role="button" data-slide="prev">
          <span><i class="fa fa-angle-left" aria-hidden="true"></i></span>
          <span class="sr-only">Previous</span>
        </a>
        <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
          <span><i class="fa fa-angle-right" aria-hidden="true"></i></span>
          <span class="sr-only">Next</span>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props:["Images"],
  async created(){
    if(this.Images){
      this.myImages = this.splitArray(this.Images, 4)
    }  
  },
  data(){
    return{
      myImages:this.Images,
      mainImage:{index:0, n:0},
    }
  },
  methods:{
    generateBase64: function generateBase64() {
      var _this = this;

      var canvas = document.createElement('CANVAS');
      var img = document.createElement('img');
      img.src = this.url;
      img.onload = function () {
        canvas.height = img.height;
        canvas.width = img.width;
        _this.base64 = canvas.toDataURL('image/png');
        canvas = null;
      };

      img.onerror = function (error) {
        _this.error = 'Could not load image, please check that the file is accessible and an image!';
      };
    },
    splitArray(array, part) {
      var tmp = [];
      for (var i = 0; i < array.length; i += part) {
        tmp.push(array.slice(i, i + part));
      }
      return tmp;
    },
    changeMainImage(index , n){
      this.mainImage.index = index
      this.mainImage.n = n
    }
  }
}
</script>
<style lang="scss" scoped>
img{
  width: 100%;
  height: auto;
}
.mainImage{
  padding: 2%;
  height: 500px;
  transition: all 300ms;
  // border: 1px solid rgba(148, 148, 148, 0.5);
  // margin-top: 20px;
  // border-radius: 10px;
  img{
    display: block;
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
.mainImage:hover{
  transform: scale(1.01);
  opacity: .8;
}
.subImage{
  margin-top: 10px;
  margin-bottom: 20px;
}
.imageItem{
  padding: 1%;
  transition: all 300ms;
}
.imageItem:hover{
  transform: scale(1.01);
  opacity: .8;
}
i{
  color: black;
  font-size: 23px;
}
.carousel-control-prev , .carousel-control-next{
  width: 30px;
  background-color: rgba(0, 0, 0, 0.1);
  border-radius: 8px
}
.carousel-control-prev:hover , .carousel-control-next:hover{
  background-color: rgba(0, 0, 0, 0.3);
}
</style>